var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3149_3660",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3149_3660",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAER0lEQVR4nO2dT4hVVRzHz5SmYtYmqCzQGF0Hk60qGkQLobAWFVhJWomgYDaEtgjaVa5koFaBK7dauRjRXZuiJsaZgYctNBeWTOPM6Mr3wOkTP95v4CHzxvfnnHN/597zgbd53HfuOV/OO/f8/pzfdS6TyWQymUwmk8lkMp0BPAg8D3wInAB+AKaAK8A80NDPvH43pdd8o7/ZJm10eLtqATwNfAKcA27TP7eAn4AjwFOuygDrgPeBi8Ai4bgLXADeA9a6qgA8rDPtb+LzL/Al8KgrK8Bq4DNgjuKRPoxIn1yZAF4CprHHZWCHSx1ZE4Fvgf+wi/RtFFjjUgTYDPxKOvwBbHEpIX9HT9u02Mi2cLtLAeBN4A7p0gDecZYBDgTeE8dCxvCxswjwhhoHZWEReNtZQtY1oE75aACvOAsAWxN98HXzgBwsWuQ1ui0qO+OF7rPVGKkKo0Wa1ZYtPt/IWF+OLfIqYJLqMR3VEaVeuKpyNKY/+SbV5aZoEEPoY0WP1AAjMdye/xQ9SgPckFBcSKH3Fj1CQ+wJKbQEUjNNxkKmBJTBM1fX58wT+jmmPo1uEQfakyGElryLMoi8a5mxHe+xvcMhhJbklpRpAK+3GdvjPbZ5JkSa1gIlFFkANvbY7oLX9DPNhSvVctEK8Hkf7T/nfKHJg2UVeVefQYt9PoWWrM5SLRcC8KqHQPJXzhfAj6RFI5LIfh+IiblE6xGWi1YmfAp9jTRoRJzJS1z1KbSFDFCLIguzPoXuxUStgshC3arQPwMHxXwFfk9wTQ4qtK+Iymlg4J7Y4/cJi+x96fjLU6c2L9P2Az2KbUFk7w9DH9u7ReChNu13K7YVkb1v7+Qcnw+2r3CPTsW2JLJ3g8WXCf4n8FgfYlsTWfjaqlOpJpGNFe41AHxnbAu3Eh9YdpNOdjmzLc7kJYasO/5rHc5sqzPZv+NfByNnqylgZj9rdCb7D2XpgORYMbHFNiyycMj5RuNqoc6o1FZaRowtF0vc7bbP3QxOqgRQtNgUL3K4BBodoJR9oEixsSFy8JSwtRHKP9TaiW1I5LBJjhGT0CclqeWe+75m6Ijdp0FF1gFviBRxmQG+EMsLOGUo728WWB9caBVbiopUlSNRRG5x2F+iekxHr1oDvJiPv0VCK7dUhZOxdG13RFmO75ad39pFh2KKPagH08vKAvCMswAwbMSQ8I24aHc6SwC7S1gY5S1nESmPY8iw6AeZMB85y2jJn5SXkbq5Ej/3Kf1zK9EH37BLCWAT8AvpMF54SZ8+99mjxi1I6dvJwvfJHs31SewhfXrBlQmajqij6mYsmlkNNq9yZQVYr4O8XoDAM1qo+xFXFWiGxd4Fzgc2dKTtMYnxVar0/HJIlQA9AXBW30bRL/Pa1qFgKQGpQzP9bAjYL5makg0kOcj6KpC5lteDzOl3E3qNXLtPf5tfD5LJZDKZTCaTyWQyrkP+Byfj0xVEmNiwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.a5ef2226d87177bfc3f1642a7a3a458c.svg";
export { ForwardRef as ReactComponent };